import validate from "validate.js";

const schema = {
  program_id: {
    presence: {
      allowEmpty: false,
      message: "^Program is required",
    },
  },
};

export const validateInvoiceConfigurationForm = (values = {}) => {
  const errors = validate(values, schema) || {};

  if (!Array.isArray(values.section_states) || values.section_states.length === 0) {
    errors.section_states = ["At least one section must be enabled"];
  }

  return Object.keys(errors).length > 0 ? errors : null;
};
